// Featured Collection — Product
// HTML5 blocks mount via video-block on load; this file pulls styles + editor remount.

// -------------------------------------
// Dependencies
// -------------------------------------

import { mountVideoBlocks } from 'snippets/video-player/video-block';
import 'snippets/card/card';
import 'snippets/icon/icon';
import './_featured-collection-product.scss';

// -------------------------------------
// Theme editor
// -------------------------------------

document.addEventListener('shopify:section:load', function (event) {
  mountVideoBlocks(event.target);
});